module.exports = __webpack_public_path__ + "static/img/cu.527aace5.png";